export default {"src":"/_next/static/media/blues-logomark-white.284adb20.svg","height":492,"width":1756,"blurWidth":0,"blurHeight":0};